var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_57_x2C__Twitter_x2C__Location_x2C__Map",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.381,
    height: 10.892,
    viewBox: "0 0 8.381 10.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37837",
    "data-name": "Group 37837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27706",
    "data-name": "Path 27706",
    d: "M106.3,55a4.192,4.192,0,0,1,4.188,4.192c0,2.1-2.369,5.31-4.171,6.7-2.323-1.885-4.209-4.568-4.209-6.7A4.193,4.193,0,0,1,106.3,55Zm2.036,4.106a2.039,2.039,0,1,0-2.039,2.039A2.039,2.039,0,0,0,108.339,59.105Z",
    transform: "translate(-102.11 -54.999)",
    fill: "#ff7979"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.75bdd9c1db7041bbc19824c55427ae06.svg";
export { ForwardRef as ReactComponent };